"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.MODAL_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var hooks_1 = require("../../../mantine-hooks/src");
var ActionIcon_1 = require("../ActionIcon/ActionIcon");
var Text_1 = require("../Text/Text");
var Paper_1 = require("../Paper/Paper");
var Overlay_1 = require("../Overlay/Overlay");
var Transition_1 = require("../Transition/Transition");
var CloseIcon_1 = require("./CloseIcon");
var Modal_styles_1 = __importStar(require("./Modal.styles"));
exports.MODAL_SIZES = Modal_styles_1.sizes;
function Modal(_a) {
    var className = _a.className, opened = _a.opened, themeOverride = _a.themeOverride, title = _a.title, onClose = _a.onClose, children = _a.children, _b = _a.hideCloseButton, hideCloseButton = _b === void 0 ? false : _b, overlayOpacity = _a.overlayOpacity, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.transitionDuration, transitionDuration = _d === void 0 ? 300 : _d, closeButtonLabel = _a.closeButtonLabel, overlayColor = _a.overlayColor, _e = _a.zIndex, zIndex = _e === void 0 ? 1000 : _e, _f = _a.overflow, overflow = _f === void 0 ? 'outside' : _f, _g = _a.transition, transition = _g === void 0 ? 'slide-down' : _g, id = _a.id, others = __rest(_a, ["className", "opened", "themeOverride", "title", "onClose", "children", "hideCloseButton", "overlayOpacity", "size", "transitionDuration", "closeButtonLabel", "overlayColor", "zIndex", "overflow", "transition", "id"]);
    var baseId = hooks_1.useId(id);
    var titleId = baseId + "-title";
    var bodyId = baseId + "-body";
    var reduceMotion = hooks_1.useReducedMotion();
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = Modal_styles_1.default({ size: size, overflow: overflow, theme: theme });
    var clickOutsideRef = hooks_1.useClickOutside(onClose);
    var focusTrapRef = hooks_1.useFocusTrap();
    var duration = reduceMotion ? 1 : transitionDuration;
    var _overlayOpacity = typeof overlayOpacity === 'number'
        ? overlayOpacity
        : theme.colorScheme === 'dark'
            ? 0.85
            : 0.75;
    hooks_1.useScrollLock(opened);
    return (react_1.default.createElement(Transition_1.GroupedTransition, { mounted: opened, transitions: {
            modal: { duration: duration, transition: transition },
            overlay: { duration: duration / 2, transition: 'fade', timingFunction: 'ease' },
        } }, function (styles) { return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.wrapper, className) }, others),
        react_1.default.createElement("div", { "data-mantine-modal-inner": true, className: classes.inner, onKeyDownCapture: function (event) { return event.nativeEvent.code === 'Escape' && onClose(); }, style: { zIndex: zIndex + 1 }, ref: focusTrapRef },
            react_1.default.createElement(Paper_1.Paper, { className: classes.modal, shadow: "lg", role: "dialog", "aria-labelledby": titleId, "aria-describedby": bodyId, "aria-modal": true, style: styles.modal, elementRef: clickOutsideRef, tabIndex: -1 },
                (title || !hideCloseButton) && (react_1.default.createElement("div", { "data-mantine-modal-header": true, className: classes.header },
                    react_1.default.createElement(Text_1.Text, { id: titleId, "data-mantine-modal-title": true, className: classes.title }, title),
                    !hideCloseButton && (react_1.default.createElement(ActionIcon_1.ActionIcon, { onClick: onClose, "aria-label": closeButtonLabel },
                        react_1.default.createElement(CloseIcon_1.CloseIcon, null))))),
                react_1.default.createElement("div", { id: bodyId, className: classes.body }, children))),
        react_1.default.createElement("div", { style: styles.overlay },
            react_1.default.createElement(Overlay_1.Overlay, { color: overlayColor || (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.black), opacity: _overlayOpacity, zIndex: zIndex })))); }));
}
exports.Modal = Modal;
Modal.displayName = '@mantine/core/Modal';
